import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { Operator } from '../models';
import {AccountService} from "./account.service";
import {Product} from "../models/product";
import {ReservationData} from "../models/reservationData";
import {start} from "repl";
import {ReservationDataList} from "../models/reservationDataList";
import {ReservationsFilter} from "../models/reservationsFilter";

@Injectable({ providedIn: 'root' })
export class ReservationDataService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll() {
        return this.http.get<ReservationDataList>(`${environment.apiEndpoint}/v1/reservations`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllWithParams(offset: number, limit: number, filters: ReservationsFilter) {
        let filtersStr = '';

        if (filters.customer) {
            filtersStr = '&filters[customer]=' + filters.customer;
        }

        return this.http.get<ReservationDataList>(`${environment.apiEndpoint}/v1/reservations?limit=` + limit +'&offset=' + offset + filtersStr , {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getByDate(startDate: string, endDate: string) {
        return this.http.get<ReservationData[]>(`${environment.apiEndpoint}/v1/reservations/by-date/` + startDate + '/' + endDate, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getById(id: string|number) {
        return this.http.get<ReservationData>(`${environment.apiEndpoint}/v1/reservations/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    update(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/reservations/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    updateUser(id, userId) {
        return this.http.put(`${environment.apiEndpoint}/v1/reservations/update-user/${id}`, {userId: userId}, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    updateDate(id, startDate, endDate) {
        return this.http.put(`${environment.apiEndpoint}/v1/reservations/update-date/${id}`, {startDate: startDate, endDate: endDate}, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    create(params) {
        return this.http.post(`${environment.apiEndpoint}/v1/reservations`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiEndpoint}/v1/reservations/` + id, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }
}
